import React from 'react'
import AutoTransformers from '../components/AutoTransformers/AutoTransformers'
import RDSOAUTO from '../components/AutoTransformers/Services/services'
import { SlideShowF } from '../components/AutoTransformers/SlideShowF/SlideShow'


const AutoTransfromerPage = () => {
  return (
    <>
    <div className='TractionDIV'/>
    <AutoTransformers/>
   <SlideShowF/>
    <RDSOAUTO/>
    
    </>
  )
}

export default AutoTransfromerPage